/* eslint-disable */
import Utils from "@/utils/Utils.js";

export class Store {
    constructor(config) {
        let objConfig = config || {};

        this.url = objConfig.url || "";
        this.listeners = objConfig.listeners || {};
        this.baseParams = objConfig.baseParams || {};

        this.rawResponse = null;

        this.allData = [];
        this.data = [];
        this.isFiltered = false;
        this.isLoading = false;

        this._sequenceStoredElements = 0;

        if (objConfig.autoLoad === true && this.url != "") {
            this.load();
        }
    }

    /**
     * Chama o listerner desejado se o mesmo estiver setado
     * - add (recordObj)
     * - beforeload
     * - clearfilter
     * - filter
     * - load
     * - removeall
     */
    _callListener(listener, param1) {
        if (this.listeners[listener]) {
            if (param1) {
                this.listeners[listener](this, param1);
            } else {
                this.listeners[listener](this);
            }
        }
    }

    /**
     * Retorna o proximo id disponivel na store
     */
    _getNextStoredId() {
        return ++this._sequenceStoredElements;
    }

    /**
     * Adiciona um novo elemento na store.
     * @param {Object} dataObj registro em formato json
     */
    add(dataObj) {
        let elementObjAux = dataObj;
        elementObjAux._storedId = this._getNextStoredId();
        this.data.push(JSON.parse(JSON.stringify(elementObjAux)));
        this.allData.push(JSON.parse(JSON.stringify(elementObjAux)));
        this._callListener("add", elementObjAux);
    }

    /**
     * Limpa o filtro da store
     */
    clearFilter() {
        this.data = this.allData;
        this.isFiltered = false;
        this._callListener("clearfilter");
    }

    /**
     * Filtra os elmentos da store
     * @param {Array} arrField campos a serem comparados
     * @param {String} value valor do campo a ser comparado
     */
    filter(arrField, value) {
        let self = this;

        let fetchFromObject = (obj, prop) => {
            if (typeof obj === "undefined") {
                return false;
            }

            let _index = prop.indexOf(".");
            if (_index > -1) {
                return fetchFromObject(
                    obj[prop.substring(0, _index)],
                    prop.substr(_index + 1)
                );
            }

            return obj[prop];
        };

        let newData = this.allData.filter((itemEl) => {
            let isMatched = false;
            arrField.forEach((field) => {
                if (!isMatched) {
                    let fieldValue = fetchFromObject(itemEl, field);
                    if (fieldValue) {
                        isMatched =
                            fieldValue
                                .toString()
                                .toLowerCase()
                                .indexOf(value.toString().toLowerCase()) >= 0;
                    }
                }
            });
            return isMatched;
        });
        this.data = newData;
        this.isFiltered = true;
        this._callListener("filter");
    }

    /**
     * Filtra os elmentos da store, com base em uma função.
     * @param {Function} fn(elemento, index) funcao para localizar os elementos.
     */
    filterByFn(fn) {
        let newData = [];
        for (let i = 0; i < this.allData.length; i++) {
            let responseFn = fn(this.allData[i], i);
            if (responseFn) {
                arrReturn.push(this.allData[i]);
            }
        }
        this.data = newData;
        this.isFiltered = true;
        this._callListener("filter");
    }

    /**
     * Retorna o índice do elemento encontrado.
     * @param {String} field campo a ser comparado
     * @param {String} value valor do campo a ser comparado
     * @param {Boolean} useAll usar todos os dados, independente de filtro (padrao False)
     */
    find(field, value, useAll) {
        let isUseAll = useAll === true ? true : false;
        let rIndex = -1;
        let self = this;
        if (isUseAll) {
            this.allData.forEach((itemEl, itemIdx) => {
                if (rIndex < 0) {
                    if (itemEl[field]) {
                        if (itemEl[field].toString() == value.toString()) {
                            rIndex = itemIdx;
                        }
                    }
                }
            });
        } else {
            this.data.forEach((itemEl, itemIdx) => {
                if (rIndex < 0) {
                    if (itemEl[field]) {
                        if (itemEl[field].toString() == value.toString()) {
                            rIndex = itemIdx;
                        }
                    }
                }
            });
        }
        return rIndex;
    }

    /**
     * Retorna um array com os índices dos elementos encontrados.
     * @param {String} field campo a ser comparado
     * @param {String} value valor do campo a ser comparado
     * @param {Boolean} useAll usar todos os dados, independente de filtro (padrao False)
     */
    findAll(field, value, useAll) {
        let isUseAll = useAll === true ? true : false;
        let self = this;
        var arrReturn = [];
        if (isUseAll) {
            this.allData.forEach((itemEl, itemIdx) => {
                if (itemEl[field]) {
                    if (itemEl[field].toString() == value.toString()) {
                        arrReturn.push(itemIdx);
                    }
                }
            });
        } else {
            this.data.forEach((itemEl, itemIdx) => {
                if (itemEl[field]) {
                    if (itemEl[field].toString() == value.toString()) {
                        arrReturn.push(itemIdx);
                    }
                }
            });
        }
        return arrReturn;
    }

    /**
     * Retorna um array com os indeces dos elementos encontrados.
     * @param {Function} fn(elemento, index) funcao para localizar os elementos.
     * @param {Boolean} useAll usar todos os dados, independente de filtro (padrao False)
     */
    findByFn(fn, useAll) {
        let isUseAll = useAll === true ? true : false;
        let arrReturn = [];
        if (isUseAll) {
            for (let i = 0; i < this.allData.length; i++) {
                let responseFn = fn(this.allData[i], i);
                if (responseFn) {
                    arrReturn.push(i);
                }
            }
        } else {
            for (let i = 0; i < this.data.length; i++) {
                let responseFn = fn(this.data[i], i);
                if (responseFn) {
                    arrReturn.push(i);
                }
            }
        }
        return arrReturn;
    }

    /**
     * Retorna o índice do elemento encontrado.
     * @param {Integer} storedId id do elemento na store
     * @param {Boolean} useAll usar todos os dados, independente de filtro (padrao False)
     */
    findById(storedId, useAll) {
        let isUseAll = useAll === true ? true : false;
        let rIndex = -1;
        if (isUseAll) {
            this.allData.forEach((itemEl, itemIdx) => {
                if (rIndex < 0) {
                    if (itemEl._storedId == storedId) {
                        rIndex = itemIdx;
                    }
                }
            });
        } else {
            this.data.forEach((itemEl, itemIdx) => {
                if (rIndex < 0) {
                    if (itemEl._storedId == storedId) {
                        rIndex = itemIdx;
                    }
                }
            });
        }
        return rIndex;
    }

    /**
     * Retorna o elemento encontrado.
     * @param {String} field parametro a ser comparado
     * @param {Mixed} value valor do parametro a ser comparado
     * @param {Boolean} useAll usar todos os dados, independente de filtro (padrao False)
     */
    get(field, value, useAll) {
        let isUseAll = useAll === true ? true : false;
        if (isUseAll) {
            let indexAll = this.find(field, value, true);
            if (indexAll >= 0) {
                return this.allData[indexAll];
            }
        } else {
            let index = this.find(field, value);
            if (index >= 0) {
                return this.data[index];
            }
        }
        return false;
    }

    /**
     * Retorna um array com os elementos encontrados.
     * @param {String} field parametro a ser comparado
     * @param {Mixed} value valor do parametro a ser comparado
     * @param {Boolean} useAll usar todos os dados, independente de filtro (padrao False)
     */
    getAll(field, value, useAll) {
        let isUseAll = useAll === true ? true : false;
        let arrReturn = [];
        if (isUseAll) {
            let arrIndexAll = this.findAll(field, value, true);
            if (arrIndexAll.length >= 0) {
                for (let i = 0; i < arrIndexAll.length; i++) {
                    arrReturn.push(this.allData[arrIndexAll[i]]);
                }
            }
        } else {
            let arrIndex = this.findAll(field, value);
            if (arrIndex.length >= 0) {
                for (let i = 0; i < arrIndex.length; i++) {
                    arrReturn.push(this.data[arrIndex[i]]);
                }
            }
        }
        return arrReturn;
    }

    /**
     * Retorna um array com os elementos encontrados.
     * @param {Function} fn(elemento, index) funcao para localizar os elementos.
     * @param {Boolean} useAll usar todos os dados, independente de filtro (padrao False)
     */
    getByFn(fn, useAll) {
        let isUseAll = useAll === true ? true : false;
        let arrReturn = [];
        if (isUseAll) {
            for (let i = 0; i < this.allData.length; i++) {
                let responseFn = fn(this.allData[i], i);
                if (responseFn) {
                    arrReturn.push(this.allData[i]);
                }
            }
        } else {
            for (let i = 0; i < this.data.length; i++) {
                let responseFn = fn(this.data[i], i);
                if (responseFn) {
                    arrReturn.push(this.data[i]);
                }
            }
        }
        return arrReturn;
    }

    /**
     * Retorna o elemento encontrado.
     * @param {Integer} storedId id do elemento na store
     * @param {Boolean} useAll usar todos os dados, independente de filtro (padrao False)
     */
    getById(storedId, useAll) {
        let isUseAll = useAll === true ? true : false;
        if (isUseAll) {
            let indexAll = this.findById(storedId, true);
            if (indexAll >= 0) {
                return this.allData[indexAll];
            }
        } else {
            let index = this.findById(storedId);
            if (index >= 0) {
                return this.data[index];
            }
        }
        return false;
    }

    /**
     * Faz uma chamada ajax na api para preencher o data e o allData
     */
    load(config) {
        let objConfig = config || {};
        let params = objConfig.params || {};
        let url = this.url || objConfig.url;

        let objParams = this.baseParams || {};
        Object.keys(params).forEach((k, i) => {
            objParams[k] = params[k];
        });

        if (!url) {
            return;
        }

        let self = this;

        this.isLoading = true;

        self._callListener("beforeload");

        Utils.apiAjax({
            url: url,
            params: objParams,
            success: (rowDataResponse, rawResponse) => {
                self.isLoading = false;
                self.rawResponse = rawResponse;
                if (rowDataResponse.success) {
                    self.data = [];
                    self.allData = [];
                    rowDataResponse.data.forEach((itemEl, itemIdx) => {
                        let elementObjAux = itemEl;
                        elementObjAux._storedId = self._getNextStoredId();
                        self.data.push(
                            JSON.parse(JSON.stringify(elementObjAux))
                        );
                        self.allData.push(
                            JSON.parse(JSON.stringify(elementObjAux))
                        );
                    });
                    self._callListener("load");
                }
            },
            failure: (rowDataResponse, rawResponse) => {
                self.isLoading = false;
                console.log(rowDataResponse);
            },
        });
    }

    /**
     * Remove o elemento encontrado.
     * @param {String} field parametro a ser comparado
     * @param {Mixed} value valor do parametro a ser comparado
     */
    remove(field, value) {
        if (field != "") {
            let arrayIndexesToRemove = [];

            this.data.forEach((itemEl, itemIdx) => {
                if (itemEl[field]) {
                    if (itemEl[field.toString()] == value.toString()) {
                        arrayIndexesToRemove.push(itemIdx);
                    }
                }
            });

            arrayIndexesToRemove.sort(function(a, b) {
                return b - a;
            });
            let arrayIndexesToRemoveLength = arrayIndexesToRemove.length;
            for (var i = 0; i < arrayIndexesToRemoveLength; i++) {
                let indexAll = this.findById(
                    this.data[arrayIndexesToRemove[i]]._storedId,
                    true
                );
                if (indexAll >= 0) {
                    this.allData.splice(indexAll, 1);
                }
                this.data.splice(arrayIndexesToRemove[i], 1);
            }
        }
    }

    /**
     * Remove todos os elementos presentes no mapa.
     */
    removeAll() {
        this.data = [];
        this.allData = [];
        self._callListener("removeall");
    }

    /**
     * Remove o elemento encontrado.
     * @param {Integer} storedId do elemento na store
     */
    removeById(storedId) {
        let index = this.findById(storedId);
        let indexAll = this.findById(storedId, true);
        if (index >= 0 || indexAll >= 0) {
            this.data.splice(index, 1);
            this.allData.splice(indexAll, 1);
            return true;
        } else {
            return false;
        }
    }

    /**
     * Remove o elemento encontrado.
     * @param {Integer} idx indice do elemento na store
     */
    removeByIndex(idx) {
        if (this.data[idx]) {
            let indexAll = this.findById(this.data[idx]._storedId, true);
            if (indexAll >= 0) {
                this.allData.splice(indexAll, 1);
            }
            this.data.splice(idx, 1);
            return true;
        } else {
            return false;
        }
    }
}